// IMPORTANT: Initialize Sentry FIRST
import { initSentry } from "./lib/sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import * as Sentry from "@sentry/react";
import { trpc, trpcClient } from "./lib/trpc";
import { ThemeProvider } from "./contexts/ThemeContext";
import App from "./App";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource/geist-mono/400.css";
import "@fontsource/geist-mono/500.css";
import "@fontsource/geist-mono/600.css";
import "@fontsource/geist-mono/700.css";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      // Disable all retries to prevent auth storm
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={({ error }) => (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Something went wrong</h1>
      <p>We've been notified and are working on a fix.</p>
      <pre style={{ marginTop: "1rem", textAlign: "left", background: "#f5f5f5", padding: "1rem", borderRadius: "4px" }}>
        {error instanceof Error ? error.message : String(error)}
      </pre>
      <button onClick={() => window.location.reload()} style={{ marginTop: "1rem", padding: "0.5rem 1rem", cursor: "pointer" }}>
        Reload Page
      </button>
    </div>
  )}>
    <ThemeProvider>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
            <Toaster
              position="top-right"
              richColors
              closeButton
              toastOptions={{
                style: {
                  backdropFilter: 'blur(12px)',
                },
                className: 'glass-card',
              }}
            />
          </BrowserRouter>
        </QueryClientProvider>
      </trpc.Provider>
    </ThemeProvider>
  </Sentry.ErrorBoundary>
);
